import React from 'react';

import Icon, { Props } from './icon';

export const CancelRecordIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props} viewBox="0 0 40 40">
      <path
        d="M25.1954 12.4528C25.8462 11.802 26.9012 11.8021 27.5521 12.4528C28.203 13.1037 28.203 14.1587 27.5521 14.8096L22.3584 20.0017L27.5521 25.1954C28.203 25.8462 28.203 26.9012 27.5521 27.5521C26.9012 28.203 25.8462 28.203 25.1954 27.5521L20.0017 22.3584L14.8096 27.5521C14.1587 28.203 13.1037 28.203 12.4528 27.5521C11.8021 26.9012 11.802 25.8462 12.4528 25.1954L17.6449 20.0017L12.4528 14.8096C11.802 14.1587 11.802 13.1037 12.4528 12.4528C13.1037 11.802 14.1587 11.802 14.8096 12.4528L20.0017 17.6449L25.1954 12.4528Z"
        fill="#F2F2F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 3.33337C29.2048 3.33337 36.6667 10.7953 36.6667 20C36.6667 29.2048 29.2048 36.6667 20 36.6667C10.7953 36.6667 3.33337 29.2048 3.33337 20C3.33337 10.7953 10.7953 3.33337 20 3.33337ZM20 6.66671C12.6362 6.66671 6.66671 12.6362 6.66671 20C6.66671 27.3638 12.6362 33.3334 20 33.3334C27.3638 33.3334 33.3334 27.3638 33.3334 20C33.3334 12.6362 27.3638 6.66671 20 6.66671Z"
        fill="#F2F2F2"
      />
    </Icon>
  );
};

export default React.memo(CancelRecordIcon);
